import { HttpClient } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IDataPropertiesOnlyRequired } from '../../reports/interfaces/reporting-data';
import { ReusableFunctions } from '../classes/reusable-functions';
import { saveAs } from 'file-saver';
import { ToastService } from './toast.service';

@Injectable({
    providedIn: 'root',
})
export class ReportExportService {
    private serverUrl = 'https://' + window.location.host;
    private version = '0.5';
    private _url = (this.serverUrl + '/api/v{version}/reporting').replace(
        '{version}',
        this.version
    );

    exports: any[];

    pollInterval: number = 2000;
    retryLimit: number = 25;

    downloadFinished = new EventEmitter<string>();

    constructor(
        private _http: HttpClient,
        private _reusableFunctions: ReusableFunctions,
        private toastService: ToastService
    ) {
        setInterval(() => {
            this.handleDownloads();
        }, this.pollInterval);
    }

    public addExport(
        properties: IDataPropertiesOnlyRequired,
        reportName: string,
        type: 'pdf' | 'excel' | 'csv'
    ) {
        if (!this.exports) {
            this.exports = [];
        }

        this.queueExport(properties, type).subscribe((res) => {
            if (res) {
                let name = this._reusableFunctions.toCamelCase(reportName);
                let toastId = new Date().getTime();

                this.exports.push({
                    properties: properties,
                    reportName: name,
                    blobIdentifier: res.blobIdentifier,
                    completed: false,
                    downloading: false,
                    retry: 0,
                    id: toastId,
                });

                this.toastService.info(
                    `${name} export is being prepared now. When it's ready, a message will appear and the file will be automatically downloaded.`,
                    {
                        timeout: 10000,
                    },
                    toastId
                );
            }
        });
    }

    private queueExport(
        properties: IDataPropertiesOnlyRequired,
        type: 'pdf' | 'excel' | 'csv'
    ): Observable<any> {
        let body = {
            parameters: JSON.stringify(properties),
            type: type,
        };

        return this._http.post<any>(this._url + '/ReportExportTo/', body);
    }

    private tryDownloadFile(download: any) {
        let body = {
            blobIdentifier: download.blobIdentifier,
        };

        download.downloading = true;
        try {
            this._http
                .post<Blob>(this._url + '/DownloadExport/', body, {
                    responseType: 'blob' as 'json',
                })
                .subscribe((res) => {
                    if (res && res.size != 0) {
                        let dateTime = this._reusableFunctions.getCurrentDateTimeStamp();
                        let reportName = download.properties.reportId + '_' + dateTime + '_.xlsx';
                        console.log('---- report excel response---');
                        console.log(res);
                        saveAs(res, reportName);

                        if (download.id) {
                            this.toastService.removeIfExists(download.id);
                        }

                        this.toastService.success(
                            `${download.reportName} export has finished downloading`
                        );

                        this.downloadFinished.emit(download.properties.reportId);

                        download.completed = true;
                    } else {
                        download.retry++;
                    }

                    download.downloading = false;
                });
        } catch (e) {
            download.downloading = false;
            download.retry++;
        }
    }

    private handleDownloads() {
        let _this = this;

        if (this.exports && this.exports.length != 0) {
            this.exports.forEach((x) => {
                if (x.downloading == false && x.completed == false && x.retry < this.retryLimit) {
                    _this.tryDownloadFile(x);

                    if (x.retry == this.retryLimit) {
                        this.toastService.warning(
                            `Something went wrong downloading ${x.reportName}`
                        );
                    }
                }
            });

            this.exports = this.exports.filter(
                (x) => x.completed == false && x.retry < this.retryLimit
            );
        }
    }
}
